/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { QUESTION } from '../../constants/terminology';

export enum ViewValues {
  SdgTarget = 'sdg-target',
  Sdg = 'sdg',
  Materiality = 'materiality',
  Standards = 'standards',
  StandardsAndFrameworks = 'standards-and-frameworks',
  Custom = 'custom',
  StandardsQuestionList = 'standardsQuestionList',
  Frameworks = 'frameworks',
  Regulatory = 'regulatory',
  Ratings = 'ratings',
  Roles = 'roles',
  Users = 'users',
  QuestionList = 'questionList',
  Group = 'group',
  QuestionPacks = 'question-packs',
  AssignedMetrics = 'assigned',
  AllPacks = 'all-packs',
  Archived = 'archived',
}

export const ViewMap: { [index in ViewValues]: { value: ViewValues, label: string } } = {
  [ViewValues.SdgTarget]: {
    value: ViewValues.Sdg,
    label: 'Sustainable Development Goal Targets'
  },
  [ViewValues.Group]: {
    value: ViewValues.Group,
    label: 'Group',
  },
  [ViewValues.Sdg]: {
    value: ViewValues.Sdg,
    label: 'Sustainable Development Goals'
  },
  [ViewValues.Materiality]: {
    value: ViewValues.Materiality,
    label: 'Materiality'
  },
  [ViewValues.StandardsAndFrameworks]: {
    value: ViewValues.StandardsAndFrameworks,
    label: 'Standards and Frameworks'
  },
  [ViewValues.Standards]: {
    value: ViewValues.Standards,
    label: 'Standards'
  },
  [ViewValues.Frameworks]: {
    value: ViewValues.Frameworks,
    label: 'Frameworks'
  },
  [ViewValues.Regulatory]: {
    value: ViewValues.Regulatory,
    label: 'Regulatory'
  },
  [ViewValues.Ratings]: {
    value: ViewValues.Ratings,
    label: 'Ratings'
  },
  [ViewValues.Roles]: {
    value: ViewValues.Roles,
    label: 'Roles'
  },
  [ViewValues.Users]: {
    value: ViewValues.Users,
    label: 'Users'
  },
  [ViewValues.QuestionList]: {
    value: ViewValues.QuestionList,
    label: QUESTION.CAPITALIZED_PLURAL
  },
  [ViewValues.StandardsQuestionList]: {
    value: ViewValues.StandardsQuestionList,
    label: `Standards ${QUESTION.PLURAL}`
  },
  [ViewValues.Custom]: {
    value: ViewValues.Custom,
    label: 'Custom Metrics'
  },
  [ViewValues.QuestionPacks]: {
    value: ViewValues.QuestionPacks,
    label: 'Core survey modules'
  },
  [ViewValues.AssignedMetrics]: {
    value: ViewValues.AssignedMetrics,
    label: 'Assigned Metrics'
  },
  [ViewValues.AllPacks]: {
    value: ViewValues.AllPacks,
    label: 'All survey modules'
  },
  [ViewValues.Archived]: {
    value: ViewValues.Archived,
    label: 'Archived'
  },
}

export const viewOptions = [
  ViewValues.Sdg,
  ViewValues.Materiality,
  ViewValues.StandardsAndFrameworks,
  ViewValues.Regulatory,
  ViewValues.Ratings,
  ViewValues.Custom,
  ViewValues.Roles,
  ViewValues.Users,
  ViewValues.QuestionPacks,
  ViewValues.AssignedMetrics,
  ViewValues.AllPacks,
].map((k: ViewValues) => ViewMap[k]);

// Virtual types that will be converted to standard or framework
export const virtualTypes = [
  ViewValues.StandardsAndFrameworks,
  ViewValues.Regulatory,
  ViewValues.Ratings,
  ViewValues.QuestionPacks,
  ViewValues.AllPacks,
  ViewValues.Archived,
] as const;

// All types that are handled by standard and frameworks
export const standardsAndFrameworkTypes = [
  ...virtualTypes,
  ViewValues.Standards,
  ViewValues.Frameworks,
] as const;
